<template>
    <div>
        <div class="content-box first" style="padding-bottom: 0px;">
            <el-form ref="searchForm" :inline="true">
                <el-form-item>
                    <el-select v-model="formData.trackIds" collapse-tags multiple filterable remote reserve-keyword
                        :remote-method="remoteMethod" :loading="selectLoading" placeholder="输入歌曲名称进行搜索"
                        prefix-icon="el-icon-search" style="width:360px">
                        <el-option v-for="(item, index) in songOptions" :key="index" :label="item.name" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button @click="search" type="primary">搜索</el-button>
                    <el-button @click="reset" type="info">重置</el-button>
                </el-form-item>
            </el-form>
            <TabsBar style="padding-top: 0px;position: relative;left: -25px;" :active="activeIndex"
                :tabs="[{ name: '歌曲', url: '/manage/trend/song' }, { name: '艺人', url: '/manage/trend/artist' }, { name: '地区', url: '/manage/trend/region' }]">
            </TabsBar>
        </div>
        <div class="content-box">
            <TimeBar ref="timeBar" v-model="timeBarValue" @changeTime="onChangeTime" @changeType="onChangeType"></TimeBar>
            <AreaChart ref="AreaChart" :series="chartSeries" :categories="chartCategories" @removeItem="removeChartTag">
            </AreaChart>
            <el-table class="m-t-6" v-loading="loading" :data="tableData" style="width: 100%">
                <template v-if="activeIndex == 0">
                    <el-table-column prop="name" label="歌曲名称" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="artist" show-overflow-tooltip label="艺人名称"></el-table-column>
                    <el-table-column prop="album" show-overflow-tooltip label="对应专辑"></el-table-column>
                </template>
                <template v-else-if="activeIndex == 1">
                    <el-table-column prop="name" show-overflow-tooltip label="艺人名称"></el-table-column>
                </template>
                <template v-else>
                    <el-table-column prop="name" show-overflow-tooltip label="国家"></el-table-column>
                </template>
                <el-table-column prop="numStr" label="使用量"></el-table-column>
                <el-table-column prop="percentum" label="占比"></el-table-column>
                <el-table-column width="100" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" :disabled="tableDisabled(scope.row.id)" class="underline"
                            @click="addChartTag(scope.row)">
                            加入对比
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page-pagination-box">
                <el-pagination background @current-change="fetchTable" :current-page.sync="formData.pageNo"
                    layout="prev, pager, next" :total="totalCount"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import AreaChart from '../components/AreaChart.vue';
import TimeBar from '../components/TimeBar.vue';
import { fetchUsageAmountChart, fetchArtistList, fetchSongList, fetchCountryList, fetchTrack } from '@/api/trend';
export default {
    components: {
        AreaChart,
        TimeBar
    },
    props: {
        activeIndex: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            formData: {
                pageNo: 1,
                pageSize: 10,
                trackIds: [],
                artistIds: [],
                countryIds: []
            },
            timeBarValue: {},
            loading: false,
            tableData: [],
            totalCount: 0,
            chartTagData: [],
            songOptions: [],
            selectLoading: false
        }
    },
    computed: {
        currentKey() {
            const { activeIndex } = this;
            if (activeIndex == 1) return 'artistIds';
            if (activeIndex == 2) return 'countryIds';
            return 'trackIds';
        },
        chartSeries() {
            const { chartTagData } = this;
            return chartTagData.map(({ name, data, id }) => {
                return {
                    name,
                    checkbox: true,
                    data,
                    id
                }
            })
        },
        chartCategories() {
            const { chartTagData } = this;
            return chartTagData.length > 0 ? chartTagData[0].categories : [];
        }
    },
    mounted() {
        this.search();
        this.remoteMethod('');
    },
    methods: {
        reset() {
            this.formData = {
                pageNo: 1,
                pageSize: 10,
                trackIds: [],
                artistIds: [],
                countryIds: []
            };
            this.$refs['timeBar'].reset();
            this.search();
        },
        // 查询歌曲
        async remoteMethod(query) {
            this.selectLoading = true;
            const response = await fetchTrack(query);
            const { state, msg, result = [] } = response.data;
            this.selectLoading = false;
            if (!state) return this.$message.error(msg);
            this.songOptions = result.map(row => ({ id: row.id, name: row.name, value: row.name }));
        },
        search() {
            this.fetchTable();
            this.addChartTag({ id: -1, name: '全部' }, true);
        },
        tableDisabled(id) {
            return this.chartTagData.some(row => row.id == id);
        },
        // 解析周日期
        parseWeeklyDate(originalString) {
            return dayjs(originalString.split('-')[0].replace(/\//g, ''), "YYYYMMDD").format();
        },
        // 更新日期周期
        onChangeTime() {
            this.fetchTable();
            this.addChartTag({ id: -1, name: '全部' }, true);
        },
        // 更新日期周期显示类型
        async onChangeType() {
            const { chartTagData } = this;
            chartTagData.map(async ({ id, name }) => await this.addChartTag({ id, name }, true));
        },
        /**
         * 更新图表数据
         * @param {*} item 添加的图表参数
         * @param {*} isCategories 是否更新图表x坐标数据
         */
        async addChartTag(item, isCategories = false) {
            const { id, name, countryId } = item;
            const { timeBarValue } = this;

            const response = await this.fetchChart({ id: id || countryId, name, value: name });
            const { playCountTrendMap } = response || {};

            let categories = isCategories ? playCountTrendMap.map(row => {
                let period = row.period;
                if (timeBarValue.type === 3) period = this.parseWeeklyDate(period);
                if (timeBarValue.type === 2) period += '01';
                return dayjs(period, "YYYYMMDD").format();
            }) : this.chartCategories;

            let data = playCountTrendMap.length > 0 ? playCountTrendMap.map(row => row.amount) : this.chartCategories.map(() => 0);

            if (item.id === -1) this.chartTagData = [];
            this.chartTagData.push({ id, name, data, categories });
            this.$nextTick(() => {
                this.$refs['AreaChart'].refresh(this.chartCategories, this.chartSeries);
            });
        },
        /**
         * 移除图表数据
         * @param {*} id 待移除的数据ID
         */
        removeChartTag(id) {
            const index = this.chartTagData.findIndex(row => row.id == id);
            this.chartTagData.splice(index, 1);
            this.$nextTick(() => {
                this.$refs['AreaChart'].refresh(this.chartCategories, this.chartSeries);
            });
        },
        // 解析数据
        getFormData() {
            const { time, type } = this.timeBarValue;
            const formData = JSON.parse(JSON.stringify(this.formData));
            if (time.length === 2) {
                formData.startTime = dayjs(time[0]).format("YYYY-MM-DD");
                formData.endTime = dayjs(time[1]).format("YYYY-MM-DD");
            }
            formData.showDateType = type;
            // 设置查询数据
            for (const key in formData) {
                if (Object.hasOwnProperty.call(formData, key)) {
                    const element = formData[key];
                    if (key === 'trackIds') formData.trackIds = JSON.stringify(element);
                    if (key === 'artistIds') formData.artistIds = JSON.stringify(element);
                    if (key === 'countryIds') formData.countryIds = JSON.stringify(element);
                }
            }
            return formData;
        },
        async fetchTable() {
            const formData = this.getFormData();
            const { activeIndex } = this;
            let response;
            if (activeIndex === 2) {
                response = await fetchCountryList(formData);
            } else if (activeIndex === 1) {
                response = await fetchArtistList(formData);
            } else if (activeIndex === 0) {
                response = await fetchSongList(formData)
            }
            const { state, msg, result } = response.data;
            this.saveLoading = false;
            if (!state) return this.$message.error(msg);
            this.tableData = result.result || [];
            this.totalCount = result.totalCount || 0;
        },
        async fetchChart(item) {
            const formData = this.getFormData();
            if (item.id && item.id !== -1) formData[this.currentKey] = JSON.stringify([item]);
            const response = await fetchUsageAmountChart(formData);
            const { state, msg, result } = response.data;
            this.saveLoading = false;
            if (!state) return this.$message.error(msg);
            return result;
        }
    }
}
</script>